import React, {Component} from 'react'
import {TextField} from '@material-ui/core'

class CustomTextField extends Component {

    render() {
        const {errorMessage, helperText, tabIndex, inputProps, ...restOfProps} = this.props

        return <TextField
            fullWidth
            onPaste={e => e.preventDefault()}
            onDrop={e => e.preventDefault()}
            spellCheck={false}
            helperText={errorMessage ? errorMessage : helperText}
            inputProps={{tabIndex, ...inputProps}}
            {...restOfProps}
        />
    }

}

export default CustomTextField